export default "__VITE_ASSET__C_lg8LiW__"